
import React from 'react';

const Asterisk = () => (
  <span className='text-danger'>*</span>
);

export default Asterisk;